import { LOGO_ICON, LOGO_WORDMARK } from '../../constants/branding';

/** Icon-only mark for nav / compact UI */
export function AppLogoIcon({ className = 'h-11 w-11 object-contain', alt = 'NMhelper' }) {
  return (
    <img src={LOGO_ICON} alt={alt} className={className} width={48} height={48} decoding="async" />
  );
}

/** Wordmark with app name — login / marketing */
export function AppLogoWordmark({
  className = 'mx-auto h-auto w-full max-h-24 max-w-[17rem] object-contain logo-wordmark-glow',
}) {
  return (
    <img
      src={LOGO_WORDMARK}
      alt="NMhelper"
      className={className}
      width={340}
      height={96}
      decoding="async"
    />
  );
}